import React from 'react';
import Reflux from 'reflux';


import Fullscreen from './components/fullscreen.jsx';

import Steps from './modules/slxstep/components/step-wrapper.jsx';
import ConfigBar from './modules/stele/components/config-bar.jsx';
import scope from './modules/stele/components/scope.jsx';
import Stele from './modules/stele/components/stele.jsx';
import Summary from './modules/stele/components/summary.jsx';
import Finish from './modules/finish/components/finish.jsx';
import DatasheetLink from './modules/stele/components/datasheet-link.jsx';
import ZoomStele from './modules/stele/components/zoom-stele.jsx';
/* eslint camelcase: 0 */
import charging_info from './modules/stele/components/charging-info.jsx';

import User from './modules/userstorage/components/userstorage.jsx';

import stepStore from './modules/slxstep/stores/step-store.js';
import stepActions from './modules/slxstep/actions/step-actions.js';

import steleStore from './modules/stele/stores/stele-store.js';
import steleActions from './modules/stele/actions/stele-actions.js';

import optionActions from './modules/stele/actions/option-actions.js';
import optionStore from './modules/stele/stores/option-store.js';

import T from './nls/translate.js';

import * as config from './config.js';
import * as stepConfig from './config-steps.js';

import steleSVG from './modules/stele/SteleSVG.js';

/* eslint react/sort-comp: 0 */
export default React.createClass({
	mixins: [
		Reflux.connect(steleStore, 'steleData'), // this.state.data entspricht parameter von trigger() bei output: des stores,
		Reflux.connect(stepStore, 'data'), // entspricht parameter von trigger() bei output: des stores
		Reflux.listenTo(optionStore, 'onOptionsChange') // Abo ohne automatisches Redraw
	],
	onOptionsChange: function(options) {
		this.options = options; // kein setState => kein Redraw
		if(options.options && options.options.paramSpot) { // bei Wechsel der Spot-Auswahl: doch Redraw
			this.setState({spotA: options.spotA, spotB: options.spotB});
		}	else if(this.state.spotA || this.state.spotB ) {
			this.setState({spotA: false, spotB: false});
		}
	},
	getInitialState: function() {
		this.chargingInfo = charging_info(this.hideInfo);
		this.toolBarItems = this.toolBarItems || [
				{className: 'slxstele-toolbar__color', onMouseDown: stepActions.switchSubStep.bind(stepActions, 'finish'), enabled: () => true},
				{className: 'slxstele-toolbar__rotate', onMouseDown: null, enabled: () => true},
				{className: 'slxstele-toolbar__zoom', onMouseDown: () => this.setState({zoom: true}), enabled: () => true},
				{className: 'slxstele-toolbar__rendering', onMouseDown: this.downloadRendering.bind(this, null), enabled: () => true},
				{className: 'slxstele-toolbar__parameters', onMouseDown: this.openParameters, enabled: () => true, content: T.current.INFOBOX.parameters},
				{className: 'slxstele-toolbar__height', onMouseDown: this.openHeight, enabled: () => true, content: T.current.INFOBOX.height},
			];
		this.partsBarItems = this.partsBarItems || [
				{className: 'slxstele-configbar__partsTitel', onMouseDown: null, enabled: () => true},
				{className: 'slxstele-configbar__wege2', imgURL: steleSVG.getPart(config.PART_MODUL_WEGE2_NAME), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_MODUL_WEGE2), enabled: () => config.PART_MODUL_WEGE2.enabled(this.state.steleData.active, this.state.steleData.partsHeight)},
				{className: 'slxstele-configbar__rgbw', imgURL: steleSVG.getPart(config.PART_MODUL_RGBW_NAME), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_MODUL_RGBW), enabled: () => config.PART_MODUL_RGBW.enabled(this.state.steleData.active, this.state.steleData.partsHeight)},
				{className: 'slxstele-configbar__aufnahme250', imgURL: steleSVG.getPart(config.PART_MODUL_AUFNAHME_250_NAME, 0, 1), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_MODUL_AUFNAHME_250), enabled: () => config.PART_MODUL_AUFNAHME_250.enabled(this.state.steleData.active, this.state.steleData.partsHeight)},
				// TODO hier die Zwischenstücke
				{className: 'slxstele-configbar__vert', imgURL: steleSVG.getPart(config.PART_ELEMENT_VERT_NAME, 0), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_ELEMENT_VERT), enabled: config.PART_ELEMENT_VERT.enabled},
				{className: 'slxstele-configbar__twinspot', imgURL: steleSVG.getPart(config.PART_ELEMENT_TWINSPOT_NAME, 0), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_ELEMENT_TWINSPOT), enabled: config.PART_ELEMENT_TWINSPOT.enabled},
				{className: 'slxstele-configbar__f500', imgURL: steleSVG.getPart(config.PART_ELEMENT_FASSADE_500_NAME, 0), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_ELEMENT_FASSADE_500), enabled: config.PART_ELEMENT_FASSADE_500.enabled},
			    //{className: 'slxstele-configbar__f1000', imgURL: 'img/stele/fassadenelement-1000.svg', onMouseDown: this.configbarMouseDown.bind(this,  config.PART_ELEMENT_FASSADE_1000), enabled: config.PART_ELEMENT_FASSADE_1000.enabled},
			];

		this.smartcityBarItems = this.smartcityBarItems || [
				{className: 'slxstele-configbar__smartcityTitel', onMouseDown: null, enabled: () => true},
				{className: 'slxstele-configbar__cam', imgURL: steleSVG.getPart(config.PART_MODUL_KAMERA_NAME), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_MODUL_KAMERA), enabled: () => config.PART_MODUL_KAMERA.enabled(this.state.steleData.active, this.state.steleData.partsHeight)},
				{className: 'slxstele-configbar__wlan', imgURL: steleSVG.getPart(config.PART_MODUL_WLAN_NAME), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_MODUL_WLAN), enabled: () => config.PART_MODUL_WLAN.enabled(this.state.steleData.active, this.state.steleData.partsHeight)},
			    {className: 'slxstele-configbar__gobo', imgURL: steleSVG.getPart(config.PART_ELEMENT_GOBO_NAME, 0), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_ELEMENT_GOBO), enabled: config.PART_ELEMENT_GOBO.enabled},
			    {className: 'slxstele-configbar__speaker', imgURL: steleSVG.getPart(config.PART_ELEMENT_SPEAKER_NAME, 0), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_ELEMENT_SPEAKER), enabled: config.PART_ELEMENT_SPEAKER.enabled},
				{className: 'slxstele-configbar__charging', imgURL: steleSVG.getPart(config.PART_MODUL_CHARGING_NAME+'1'), onMouseDown: this.configbarMouseDown.bind(this,  config.PART_MODUL_CHARGING), enabled: () => config.PART_MODUL_CHARGING.enabled(this.state.steleData.active, this.state.steleData.partsHeight, this.state.steleData.charging)},
			];

		// disabled heißt hier aktuell aktiv, Parameter ist die stele
		this.parameterBarItems = this.parameterBarItems || [
					{
						className: 'slxstele-parametersbar-hdist', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-hdist__left',
						onMouseDown: this.paramDirectionMouseDown.bind(this, config.F_H_LEFT, true),
						enabled: this.horizEnabled.bind(this, config.F_H_LEFT)
					},
					{
						className: 'slxstele-parametersbar-hdist__right',
						onMouseDown: this.paramDirectionMouseDown.bind(this, config.F_H_RIGHT, true),
						enabled: this.horizEnabled.bind(this, config.F_H_RIGHT)
					},
					{
						className: 'slxstele-parametersbar-hdist__sym',
						onMouseDown: this.paramDirectionMouseDown.bind(this, config.F_H_SYM, true),
						enabled: this.horizEnabled.bind(this, config.F_H_SYM)
					},
					{
						className: 'slxstele-parametersbar-vdist', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-vdist__par',
						onMouseDown: () => {
							this.paramDirectionMouseDown(config.F_V_PAR, false);
							stepActions.switchSubStep('params-fassade');
						},
						enabled: this.vertEnabled.bind(this, config.F_V_PAR)
					},
					{
						className: 'slxstele-parametersbar-vdist__soft',
						onMouseDown: () => {
							this.paramDirectionMouseDown(config.F_V_SOFT, false);
							stepActions.switchSubStep('params-fassade');
						},
						enabled: this.vertEnabled.bind(this, config.F_V_SOFT)
					},
					{
						className: 'slxstele-parametersbar-vdist__strong',
						onMouseDown: () => {
							this.paramDirectionMouseDown(config.F_V_STRONG, false);
							stepActions.switchSubStep('params-fassade');
						},
						enabled: this.vertEnabled.bind(this, config.F_V_STRONG)
					},
					{
						className: 'slxstele-parametersbar-vdist__near',
						onMouseDown: () => {
							this.paramDirectionMouseDown(config.F_V_NEAR_DOWN, false);
							stepActions.switchSubStep('params-fassadeDown');
						},
						enabled: this.vertEnabled.bind(this, config.F_V_NEAR_DOWN)
					},
					{
						className: 'slxstele-parametersbar-vdist__down',
						onMouseDown: () => {
							this.paramDirectionMouseDown(config.F_V_DOWN, false);
							stepActions.switchSubStep('params-fassadeDown');
						},
						enabled: this.vertEnabled.bind(this, config.F_V_DOWN)
					},


					{
						className: 'slxstele-parametersbar-spota', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-spota__narrow',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_SPOT, true),
						enabled: this.spotAEnabled.bind(this, config.TS_SPOT)
					},
					{
						className: 'slxstele-parametersbar-spota__medspot',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_MEDSPOT, true),
						enabled: this.spotAEnabled.bind(this, config.TS_MEDSPOT)
					},
					{
						className: 'slxstele-parametersbar-spota__middle',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_MEDIUM, true),
						enabled: this.spotAEnabled.bind(this, config.TS_MEDIUM)
					},

					{
						className: 'slxstele-parametersbar-brennweite', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-gobo45',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.G_45),
						enabled: this.childTypeEnabled.bind(this, config.G_45)
					},
					{
						className: 'slxstele-parametersbar-gobo63',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.G_63),
						enabled: this.childTypeEnabled.bind(this, config.G_63)
					},
					{
						className: 'slxstele-parametersbar-gobo85',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.G_85),
						enabled: this.childTypeEnabled.bind(this, config.G_85)
					},
					{
						className: 'slxstele-parametersbar-gobo135',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.G_135),
						enabled: this.childTypeEnabled.bind(this, config.G_135)
					},
					//{ className: 'slxstele-parametersbar-spota__wide',
					//	onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_FLOOD, true),
					//	enabled: this.spotAEnabled.bind(this, config.TS_FLOOD)
					//},
					//{ className: 'slxstele-parametersbar-spotb', onMouseDown: null, enabled: () => true},
					//{ className: 'slxstele-parametersbar-spotb__narrow',
					//	onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_SPOT, false),
					//	enabled: this.spotBEnabled.bind(this, config.TS_SPOT)
					//},
					//{ className: 'slxstele-parametersbar-spotb__middle',
					//	onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_MEDIUM, false),
					//	enabled: this.spotBEnabled.bind(this, config.TS_MEDIUM)
					//},
					////{ className: 'slxstele-parametersbar-spotb__wide',
					////	onMouseDown: this.paramTypeMouseDown.bind(this, config.TS_FLOOD, false),
					////	enabled: this.spotBEnabled.bind(this, config.TS_FLOOD)
					////},
					{
						className: 'slxstele-parametersbar-spot', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-spot__a',
						onMouseDown: optionActions.setSpot.bind(optionActions, true, false),
						enabled: () => !this.state.spotA
					},
					{
						className: 'slxstele-parametersbar-spot__b',
						onMouseDown: optionActions.setSpot.bind(optionActions, false, true),
						enabled: () => !this.state.spotB
					},
					// Wege
					{
						className: 'slxstele-prarmetersbar-wege-sym__title', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-prarmetersbar-wege-sym__icon',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.W_SYM, undefined),
						enabled: this.wegeEnabled.bind(this, config.W_SYM)
					},
					{
						className: 'slxstele-prarmetersbar-wege-asym__title', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-prarmetersbar-wege-asym__icon',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.W_ASYM, undefined),
						enabled: this.wegeEnabled.bind(this, config.W_ASYM)
					},
					{
						className: 'slxstele-prarmetersbar-wege-street__title', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-prarmetersbar-wege-street__icon',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.W_ASYM_STREET, undefined),
						enabled: this.wegeEnabled.bind(this, config.W_ASYM_STREET)
					},
					{
						className: 'slxstele-prarmetersbar-wege-pedestrian__title', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-prarmetersbar-wege-pedestrian__icon',
						onMouseDown: this.paramTypeMouseDown.bind(this, config.W_ASYM_PEDESTRIAN, undefined),
						enabled: this.wegeEnabled.bind(this, config.W_ASYM_PEDESTRIAN)
					},

					{
						className: 'slxstele-parametersbar-lichtfarbe', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-k2200',
						onMouseDown: this.paramLightColorMouseDown.bind(this, true, true),
						enabled: this.lightColorEnabled.bind(this, true, true)
					},
					{
						className: 'slxstele-parametersbar-k2700',
						onMouseDown: this.paramLightColorMouseDown.bind(this, true, false),
						enabled: this.lightColorEnabled.bind(this, true, false)
					},
					{
						className: 'slxstele-parametersbar-k3000',
						onMouseDown: this.paramLightColorMouseDown.bind(this, false, true),
						enabled: this.lightColorEnabled.bind(this, false, true)
					},
					{
						className: 'slxstele-parametersbar-k4000',
						onMouseDown: this.paramLightColorMouseDown.bind(this, false, false),
						enabled: this.lightColorEnabled.bind(this, false, false)
					},

					{
						className: 'slxstele-parametersbar-reflektor', onMouseDown: null, enabled: () => true
					},
					{
						className: 'slxstele-parametersbar-silber',
						onMouseDown: this.paramGoldMouseDown.bind(this, false),
						enabled: this.goldEnabled.bind(this, false),
					},
					{
						className: 'slxstele-parametersbar-gold',
						onMouseDown: this.paramGoldMouseDown.bind(this, true),
						enabled: this.goldEnabled.bind(this, true),
					},
				];

			return {spotA: false, spotB: false, zoom: false};
	},
	downloadRendering: function(ev) {
		if(ev /*&& isFunction(ev.stopPropagation)*/) ev.preventDefault(); // ev.stopPropagation();
		const iframe=document.createElement('iframe');
		//iframe.className = 'visuallyhidden';
		iframe.style.display = 'none';
		iframe.src = 'php/image.php?data=' + steleStore.getKey();
		document.body.appendChild(iframe);
	},
	hideZoom: function() {
		this.setState({zoom: false});
	},
	showInfo: function(e) {
		this.setState({info: true});
	},
	hideInfo: function() {
		this.setState({info: false});
	},
	childTypeEnabled: function(value, stele, options) {
		return (stele && options && options.options && options.options.idxs.child !== null &&
			stele[options.options.idxs.parent].children[options.options.idxs.child].type !== value);
	},
	horizEnabled: function(value, stele, options) {
		return (stele && options && options.options && options.options.idxs.child !== null &&
			stele[options.options.idxs.parent].children[options.options.idxs.child].horiz !== value);
	},
	vertEnabled: function(value, stele, options) {
		return (stele && options && options.options && options.options.idxs.child !== null &&
		stele[options.options.idxs.parent].children[options.options.idxs.child].vert !== value);
	},
	spotAEnabled: function(value, stele, options) {
		return (stele && options && options.options && options.options.idxs.child !== null &&
		stele[options.options.idxs.parent].children[options.options.idxs.child].a &&
		stele[options.options.idxs.parent].children[options.options.idxs.child].a.type !== value);
	},
	spotBEnabled: function(value, stele, options) {
		return (stele && options && options.options && options.options.idxs.child !== null &&
		stele[options.options.idxs.parent].children[options.options.idxs.child].b &&
		stele[options.options.idxs.parent].children[options.options.idxs.child].b.type !== value);
	},
	wegeEnabled: function(value, stele, options) {
		return (stele && options && options.options &&
			stele[options.options.idxs.parent].type !== value);
	},
	lightColorEnabled: function(k2xxx, k3000, stele, options) {
		// das !! bei k2xxx ist notwendig, da k2xxx nicht überall als property vorhanden ist. k3000 sollte es sein
		// die große Negation vor dem ? ist weil enabled hier umgekehrt definiert ist: false markiert den aktuellen Wert
		return (stele && options && options.options && ! (
			options.options.idxs.child !== null ?
				k2xxx === (!!stele[options.options.idxs.parent].children[options.options.idxs.child].k2xxx) && k3000 === stele[options.options.idxs.parent].children[options.options.idxs.child].k3000 :
				k2xxx === (!!stele[options.options.idxs.parent].k2xxx) && k3000 === stele[options.options.idxs.parent].k3000
		));
	},
	goldEnabled: function (gold, stele, options) {
		return (stele && options && options.options &&
			stele[options.options.idxs.parent].gold !== gold);
	},
	paramDirectionMouseDown: function(value, horiz) {
		steleActions.setDirection(value, this.options.options.idxs.parent, this.options.options.idxs.child, horiz);
	},
	paramTypeMouseDown: function(value, spotA) {
		steleActions.setType(value, this.options.options.idxs.parent, this.options.options.idxs.child, spotA);
	},
	paramLightColorMouseDown: function(k2xxx, k3000) {
		steleActions.setLightColor(k2xxx, k3000, this.options.options.idxs.parent, this.options.options.idxs.child);
	},
	paramGoldMouseDown: function (gold) {
		steleActions.setGold(gold, this.options.options.idxs.parent, this.options.options.idxs.child);
	},
	// eintragen in die liste mit this.configbarMouseDown.bind(this, partspec) wodurch eine f(ev) entsteht
	configbarMouseDown: function(partspec, clientRect, ev) {
		//console.log('configbarMouseDown', partspec, clientRect, ev);
		this.refs.stele.startDragAdd(partspec, clientRect, ev, false);
	},
	openHeight: function() {
		optionActions.clear();
		stepActions.switchStep(stepConfig.STEP_HEIGHT, '');
	},
	openParameters: function() {
		optionActions.clear();
		stepActions.switchStep(stepConfig.STEP_PARAMETERS, '');
	},
	renderInfobox: function(parents, childs) {
		return (<div className="slxstele-infobox">
			<div className="slxstele-infobox__entry"><span>{parents}</span>{parents===1?T.current.INFOBOX.element:T.current.INFOBOX.elements}</div>
			<div className="slxstele-infobox__entry"><span>{childs}</span>{childs===1?T.current.INFOBOX.inset:T.current.INFOBOX.insets}</div>
			<div className="slxstele-infobox__entry"><span>{this.state.steleData.charging.count}</span>{this.state.steleData.charging===1?T.current.INFOBOX.charging:T.current.INFOBOX.chargings}</div>
			{/*className="slx-stele-options__distribution" onClick={this.switchToParameters}>*/}
			{/*<div className="slxstele-infobox__distribution" role="button" onClick={this.openParameters}>{T.current.INFOBOX.parameters}</div>
			<div className="slxstele-infobox__height" role="button" onClick={this.openHeight}>{T.current.INFOBOX.height}</div>*/}
		</div>);
	},
	render: function() {
		const selectingScope = (this.state.data.name===stepConfig.STEP_SCOPE);
		const summary = (this.state.data.name===stepConfig.STEP_SUMMARY);
		const globalStele = !(selectingScope || summary || this.state.data.name === stepConfig.STEP_DATASHEET );

		if(!this.state.stele)
			this.state.stele = <Stele ref="stele" showInfo={this.showInfo} />;
		if(summary && !this.state.summary)
			this.state.summary = <Summary />;

		const activeStele = this.state.steleData.active;
		let sumChildren = 0;
		activeStele.forEach( part => {
			if(part.children)
				sumChildren += part.children.length;
		});
		const parents =  (activeStele.length);
			//+ /*Mast*/1 + ((!activeStele || activeStele.length===0 || (activeStele[0].name !== config.PART_MODUL_WEGE_NAME && activeStele[0].name !== config.PART_MODUL_WEGE2_NAME)) ? 1 : 0);

		return (
				<Steps>
					<ConfigBar parts={this.toolBarItems} name="toolbar" />
					<ConfigBar parts={this.partsBarItems} name="partsbar slxstele-configbar" />
					<ConfigBar parts={this.smartcityBarItems} name="smartcitybar slxstele-configbar" />
					{this.state.data.name==='parameters'?<ConfigBar parts={this.parameterBarItems} needsOptionStore={true} name="parameterbar slxstele-configbar"  />:<div />}
					<User />
					{/*TODO this.state.data.substep === 'color'? <Finish /> : <div /> TODO update FinishStore with current Finish TODO clear color on button 'X' */}<Finish />

					{selectingScope ? scope(this.state.stele) : <div />}

					{globalStele?this.state.stele:<div />}
					{summary?this.state.summary:null}
					{!(globalStele||selectingScope||summary) ? <DatasheetLink />  : null}
					{this.renderInfobox(parents, sumChildren)}
					{this.state.zoom ?
						<Fullscreen hideCallback={this.hideZoom} >
							<div className="slxstele-zoom__download" onClick={this.downloadRendering} role="button">{T.current.STELE.RENDERING_DOWNLAOD}</div>
							<ZoomStele />
						</Fullscreen> :
							null
					}
					{this.state.info ?
						this.chargingInfo :
						null
					}
				</Steps>
		);
	}
});
